import React, {useEffect, useState} from "react"

import "./Test.css"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import GroupTab from "../../component/Test/GroupTab"
import PreviewModal from "../../component/Modal/PreviewModal"
import {getDateStr, getDateString, retrieveData, sendRequest} from "../../common";
import {ApplyTest} from "../../component/Test/PersonalCreate";
import {useNavigate, useParams} from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

function GroupWaiting() {
	const navigate = useNavigate()
	const {groupId} = useParams()
	const [previewOpen, setPreviewOpen] = useState(false)
	const showPreview = () => {
		setPreviewOpen(true)
	}

	const [user, setUser] = useState()

	const [applyGroups, setApplyGroups] = useState([])
	const [applyGroup, setApplyGroup] = useState()
	const [selected, setSelected] = useState([])
	const [sendAll, setSendAll] = useState(false)
	const [organization, setOrganization] = useState()
	const [inquiryPhone, setInquiryPhone] = useState()
	const [loading, setLoading] = useState(false)
	// const [isSending, setIsSending] = useState(false)

	useEffect(() => {
		setLoading(true)
		setTimeout(() => setLoading(false), 1000)
	}, [applyGroup]);

	const getApplyGroups = (groupId) => {
		setLoading(true)
		sendRequest('test/apply-group/?isMy=1&size=500', 'GET', null, data => {
			setApplyGroups(data)
			if (groupId) {
				setApplyGroup(data?.filter(item => item?.id == groupId)?.pop())
			} else if (applyGroup?.id) {
				setApplyGroup(data?.filter(item => item?.id === applyGroup?.id)?.pop())
			}
			setLoading(false)
		}, (data, code) => {
			setLoading(false)
		})
	}

	const getApplyGroupDetail = (groupId) => {
		sendRequest(`test/apply-group/${groupId}/`, 'GET', null, data => {
			setApplyGroup(data)
		})
	}

	useEffect(() => {
		if(applyGroup?.id) {
			getApplyGroupDetail(applyGroup?.id)
		}
	}, [applyGroup?.id]);

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			setOrganization(user?.organization)
			setInquiryPhone(user?.inquiryPhone)
		})
		getApplyGroups(groupId)
	}, [groupId])

	const onSelected = (checked, id) => {
		if (checked) {
			selected.push(id)
			setSelected(Object.assign([], selected))
		} else {
			const index = selected.indexOf(id)
			if (index !== -1) {
				selected.splice(index, 1)
				setSelected(Object.assign([], selected))
			}
		}
	}

	const deleteSelected = (selected, index) => {
		if (selected?.length - 1 < index) {
			alert('삭제 되었습니다.')
			setSelected([])
			getApplyGroupDetail(applyGroup?.id)
			// getApplyGroups(groupId)
			return
		}

		sendRequest(`test/apply-test/${selected[index]}/`, 'DELETE', null, data => {
			deleteSelected(selected, index + 1)
		})
	}

	let isLoading = false
	const sendCodes = () => {
		if (isLoading) return
		isLoading = true
		// setIsSending(true)
		const applyTestIds = sendAll ? applyGroup?.applyTests?.map(item => item.id) : selected
		// let timeout = applyTestIds?.length * 200
		setTimeout(() => alert('모두 발송 처리 되었습니다. 잠시 후 발송완료 목표에서 보실 수 있습니다.'), 1000)
		// setTimeout(() => {
		// 	setIsSending(false)
		// 	navigate(`/group-code/send-complete/${applyGroup?.id}`)
		// }, timeout)
		sendRequest('test/send-apply-test/', 'POST', {
			applyTestIds: applyTestIds,
			organization,
			inquiryPhone
		}, data => {
			setPreviewOpen(false)
			getApplyGroups()
			navigate(`/group-code/send-complete/${applyGroup?.id}`)
			isLoading = false
		}, (data, code) => {
			isLoading = false
		})
	}

	return (
		<>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"단체검사 인증코드"} />
					<div className="testWrap">
						<GroupTab isSecond={true} />
						<section className="groupCode">
							<form name="groupCode">
								<div className="groupForm">
									<div className="formFlex">
										<div className="formWrap">
											<div className="formItem">
												<div className="formBody">
													<span className="selectWrap">
														<select name="" onChange={e => {
															setApplyGroup(applyGroups[e.target.value])
														}}
															value={applyGroups?.findIndex(item => item?.id === applyGroup?.id)}
														>
															<option defaultValue="">그룹을 선택해주세요</option>
															{applyGroups?.map((item, index) => {
																return (
																	<option value={index}>{item?.name}</option>
																)
															})}
														</select>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								{applyGroup?.id ?
									<>
										<div className="groupName">
											<h4>{applyGroup?.name}</h4>
											{/*<p>검사기간*/}
											{/*	: {getDateStr(new Date(applyGroup?.startDateTime))} ~ {getDateStr(new Date(applyGroup?.endDateTime))}</p>*/}
										</div>
										<div className="tableTab">
											<div className="tableBtn">
												<button type="button" onClick={() => deleteSelected(selected, 0)}>선택 삭제</button>
											</div>
											<span>총 {selected.length}명</span>
										</div>
									</>
									: null
								}
								<div className="testTableWrap">
									<table className="testTable">
										<colgroup>
											<col width="5%" />
											<col width="15%" />
											<col width="10%" />
											<col width="10%" />
											<col width="15%" />
											<col width="10%" />
											<col width="15%" />
											<col width="10%" />
											<col width="10%" />
										</colgroup>
										<thead>
											<tr>
												<th>
													<div className="formCheckbox">
														<input type="checkbox" id="tableSelectAll"
																	 onChange={e => {
																		 if (e.target.checked) {
																			 setSelected(applyGroup?.applyTests?.map((item, index) => item?.id))
																		 } else {
																			 setSelected([])
																		 }
																	 }}
														/>
														<label htmlFor="tableSelectAll"></label>
													</div>
												</th>
												<th>검사종류</th>
												<th>
													이름 <span className="required">*</span>
												</th>
												<th>생년월일</th>
												<th>개인고유번호</th>
												<th>소속기관</th>
												<th>
													이메일 <span className="required">*</span>
												</th>
												<th>
													휴대폰 번호 <span className="required">*</span>
												</th>
												<th>
													규준집단 <span className="required">*</span>
												</th>
											</tr>
										</thead>
										<tbody>
										{applyGroup?.applyTests?.filter(item => !item.isSent)?.map((item, index) => {
											return (
												<tr>
													<td>
														<div className="formCheckbox">
															<input key={`tableSelect-${item?.id}`}
																		 type="checkbox" id={`tableSelect${index}`}
																		 required
																		 checked={selected?.indexOf(item?.id) !== -1}
																		 onChange={e => onSelected(e.target.checked, item?.id)}/>
															<label htmlFor={`tableSelect${index}`}></label>
														</div>
													</td>
													<td>{item?.test?.name}</td>
													<td>{item?.name}</td>
													<td>{item?.birth}</td>
													<td>{item?.applyNumber}</td>
													<td>{item?.organization}</td>
													<td>{item?.email}</td>
													<td>{item?.phone}</td>
													<td>
													<span>
														<select value={item?.group} disabled={true} name="">
															<option defaultValue="">일반 성인</option>
															<option defaultValue="">대학생</option>
															<option defaultValue="">고등학생</option>
															<option defaultValue="">중학생</option>
															<option defaultValue="">초등학생</option>
														</select>
													</span>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</div>
								<div className="testBtnWrap">
									<button type="button" onClick={() => {
										setSelected(applyGroup?.applyTests?.map((item, index) => item?.id))
										setSendAll(true)
										showPreview()
									}}>전체 발송</button>
									<button type="button" onClick={() => {
										if (!selected?.length) {
											alert('보낼 명단을 선택해 주세요.')
											return
										}
										setSendAll(false)
										showPreview()
									}} className="keyBtn">
										선택 발송
									</button>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>

			{previewOpen && (
				<PreviewModal
					setPreviewOpen={setPreviewOpen}
					count={selected?.length}
					organization={organization}
					inquiryPhone={inquiryPhone}
					email={'kn820425@gmail.com'}
					send={"050-6607-1258"}
					setOrganization={setOrganization}
					setInquiryPhone={setInquiryPhone}
					user={user}
					onSend={sendCodes}
				/>
			)}

			{loading && (
				<ClipLoader
					color={'#333'}
					loading={loading}
					cssOverride={{
						position: "fixed",
						display: "block",
						margin: "0 auto",
						top: 300,
						left: '50%',
						zIndex: 9999999
					}}
					size={100}
					aria-label="Loading Spinner"
					data-testid="loader"
				/>
			)}

			<RightFooter />
		</>
	)
}

export default GroupWaiting
